<template>
  <!-- 身份证照片识别弹窗 -->
  <van-popup
    class="idcard_popup"
    v-model="show"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <van-sticky class="title_div">
      <div class="title">
        <van-icon name="arrow-left" @click="show = false" />
        身份证识别
      </div>
    </van-sticky>
    <div class="upload_idcard">
      <div class="card_po">
        <van-uploader
          v-model="idcardPofileList"
          :max-count="1"
          accept="image/*"
          preview-size="100"
          :after-read="afterReadPo"
        />
        <div style="font-size:14px;text-align: center;padding: 10px 0;">
          点击上传身份证人像面
        </div>
      </div>
      <div class="card_back">
        <van-uploader
          v-model="idcardBafileList"
          :max-count="1"
          accept="image/*"
          preview-size="100"
          :after-read="afterReadBa"
        />
        <div style="font-size:14px;text-align: center;padding: 10px 0;">
          点击上传身份证国徽面
        </div>
      </div>
    </div>
    <div class="idcard_form">
      <van-overlay
        :show="idcardFormLoading"
        z-index="5000"
        @click="idcardFormLoading = false"
      >
        <van-loading size="24px" vertical color="#0094ff" style="top:50%"
          >加载中...</van-loading
        >
      </van-overlay>

      <van-form style="position:relative">
        <van-image
          width="100"
          height="123"
          radius="10"
          :src="idcardForm.photo"
          style="position: absolute;top: 15px;right: 10px;z-index: 2000;"
        />
        <van-field
          v-model="idcardForm.empname"
          label="姓名"
          placeholder="请输入"
        />
        <van-field
          v-model="idcardForm.sex"
          label="性别"
          readonly
          placeholder="请选择"
          @click="showSexPicker = true"
        />
        <van-popup v-model="showSexPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="['男', '女']"
            @confirm="onSexConfirm"
            @cancel="showSexPicker = false"
          />
        </van-popup>
        <van-field
          v-model="idcardForm.nation"
          label="民族"
          readonly
          placeholder="请选择"
          @click="showMzPic()"
        />
        <van-popup v-model="showMzPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="mzColumns"
            @confirm="onMzConfirm"
            @cancel="showMzPicker = false"
          />
        </van-popup>
        <van-field
          v-model="idcardForm.birthday"
          label="出生"
          readonly
          placeholder="请选择"
          @click="showICDate('birthday')"
        />
        <van-field
          v-model="idcardForm.regplace"
          label="住址"
          placeholder="请输入"
        />
        <van-field
          v-model="idcardForm.idcardnum"
          label="身份证号码"
          placeholder="请输入"
        />
        <van-field
          v-model="idcardForm.regpolicestation"
          label="签发机关"
          placeholder="请输入"
        />
        <van-field
          v-model="idcardForm.idbd"
          label="签发日期"
          readonly
          placeholder="请选择"
          @click="showICDate('idbd')"
        />
        <van-field
          v-model="idcardForm.ided"
          label="失效日期"
          readonly
          placeholder="请选择"
          @click="showICDate('ided')"
        />

        <!-- 日期选择 -->
        <van-popup v-model="showICDatePicker" position="bottom">
          <van-datetime-picker
            v-model="ICDate"
            type="date"
            title="选择年月日"
            :min-date="ICDateMinDate"
            :max-date="ICDateMaxDate"
            @confirm="onConfirmICDate"
            @cancel="showICDatePicker = false"
          />
        </van-popup>
      </van-form>
    </div>
    <div class="idcard_foot">
      <van-button type="info" @click="saveIDcardInfo"
        >保存身份证信息</van-button
      >
    </div>
  </van-popup>
</template>

<script>
import {
  GetFilterDropDownList,
  getIdCardFrontInfo,
  getIdCardBackInfo
} from '@api/wx.js'
import Compressor from 'compressorjs'
import { parseTime } from '@/utils'
export default {
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      show: false, // 是否显示
      idcardPofileList: [],
      idcardBafileList: [],
      idcardForm: {
        empname: '',
        sex: '',
        nation: '',
        birthday: '',
        regplace: '',
        idcardnum: '',
        photo: '',
        regpolicestation: '',
        idbd: '',
        ided: ''
      },
      idcardFormLoading: false,
      showSexPicker: false,
      showMzPicker: false,
      showTimePicker: false,
      mzColumns: [],
      showICDatePicker: false,
      ICDate: new Date(),
      ICDateMinDate: new Date(1900, 0, 1),
      ICDateMaxDate: new Date(2200, 12, 1),
      choiceICDate: ''
    }
  },
  watch: {
    show(n) {
      if (!n) {
        this.idcardPofileList = []
        this.idcardBafileList = []
        this.idcardForm = {
          empname: '',
          sex: '',
          nation: '',
          birthday: '',
          regplace: '',
          idcardnum: '',
          photo: '',
          regpolicestation: '',
          idbd: '',
          ided: ''
        }
      }
    },    
  },
  methods: {
    // 识别身份证正面
    async afterReadPo(file) {
      // 压缩图片
      let quality = 0.6
      if (
        file.file.size >= 1024 * 1024 * 0.5 &&
        1024 * 1024 * 1 > file.file.size
      ) {
        quality = 0.8
      }
      if (
        file.file.size >= 1024 * 1024 * 1 &&
        1024 * 1024 * 2 > file.file.size
      ) {
        quality = 0.6
      }
      if (
        file.file.size >= 1024 * 1024 * 2 &&
        1024 * 1024 * 5 > file.file.size
      ) {
        quality = 0.4
      }
      if (file.file.size >= 1024 * 1024 * 5) {
        quality = 0.2
      }
      file.file = await this.compressorImage(file.file, 'file', quality)
      await this.getBase64(file.file).then(res => {
        file.content = res //.split('base64,')[1]
      })
      const ext = file.file.type ? file.file.type.split('/')[1] : 'png'
      this.idcardFormLoading = true
      let base64 = file.content
      if (base64) {
        getIdCardFrontInfo({
          photo: base64
        })
          .then(res => {
            if (res.data.length > 0) {
              this.idcardForm.empname = res.data[0].empname
              this.idcardForm.sex = res.data[0].sex
              this.idcardForm.nation = res.data[0].nation
              this.idcardForm.birthday = res.data[0].birthday
              this.idcardForm.regplace = res.data[0].regplace
              this.idcardForm.idcardnum = res.data[0].idcardnum
              this.idcardForm.photo = res.data[0].photo
                ? 'data:image/' + ext + ';base64,' + res.data[0].photo
                : ''
            }
          })
          .finally(() => {
            this.idcardFormLoading = false
          })
      } else {
        this.idcardFormLoading = false
      }
    },
    // 识别身份证反面
    async afterReadBa(file) {
      // 压缩图片
      let quality = 0.6
      if (
        file.file.size >= 1024 * 1024 * 0.5 &&
        1024 * 1024 * 1 > file.file.size
      ) {
        quality = 0.8
      }
      if (
        file.file.size >= 1024 * 1024 * 1 &&
        1024 * 1024 * 2 > file.file.size
      ) {
        quality = 0.6
      }
      if (
        file.file.size >= 1024 * 1024 * 2 &&
        1024 * 1024 * 5 > file.file.size
      ) {
        quality = 0.4
      }
      if (file.file.size >= 1024 * 1024 * 5) {
        quality = 0.2
      }
      file.file = await this.compressorImage(file.file, 'file', quality)
      await this.getBase64(file.file).then(res => {
        file.content = res //.split('base64,')[1]
      })
      const ext = file.file.type ? file.file.type.split('/')[1] : 'png'
      this.idcardFormLoading = true
      let base64 = file.content
      if (base64) {
        getIdCardBackInfo({
          photo: base64
        })
          .then(res => {
            if (res.data.length > 0) {
              this.idcardForm.regpolicestation = res.data[0].regpolicestation
              this.idcardForm.idbd = res.data[0].idbd
              if (
                res.data[0].ided &&
                isNaN(res.data[0].ided) &&
                !isNaN(Date.parse(res.data[0].ided))
              ) {
                this.idcardForm.ided = res.data[0].ided
              } else {
                this.idcardForm.ided = ''
              }
            }
          })
          .finally(() => {
            this.idcardFormLoading = false
          })
      } else {
        this.idcardFormLoading = false
      }
    },
    // 压缩图片
    compressorImage(image, backType, quality) {
      console.log(image, backType, quality, 'filefilefile')
      return new Promise((resolve, reject) => {
        new Compressor(image, {
          quality: quality || 0.8,
          success(result) {
            let lastIndexOf = image.name.lastIndexOf('.')
            let name = image.name.substr(0, lastIndexOf) + '.png'
            // console.log(image, 'image.type', name);
            let file = new File([result], name, { type: 'image/png' })
            console.log(file, 'filefilefile')
            if (!backType || backType == 'blob') {
              resolve(result)
            } else if (backType == 'file') {
              resolve(file)
            } else {
              resolve(file)
            }
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
            reject(err)
          }
        })
      })
    },
    // 文件转base64
    getBase64(file) {
      const tempFile = file
      const type = tempFile.type
      const size = tempFile.size
      // const newName = new Date().getTime() + tempFile.name
      const newName = Math.round(Math.random() * 1000000) + tempFile.name
      let uploadFile = new File([tempFile], newName, { type, size })
      // if (size >= 300000)      {
      //   // 压缩？
      //   // alert(tempFile.size);
      // } else      {

      // }
      return new Promise(function(resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(uploadFile)
        reader.onload = function() {
          imgResult = reader.result
        }
        reader.onerror = function(error) {
          reject(error)
        }
        reader.onloadend = function() {
          resolve(imgResult)
        }
      })
    },
    // 选择名族
    showMzPic() {
      GetFilterDropDownList({
        moduleno: '201',
        username: this.userInfo.username,
        listsql: '@民族'
      }).then(res => {
        this.mzColumns = res.data.map(it => {
          return it.dicvalue
        })
      })
      this.showMzPicker = true
    },
    // 名族选中
    onMzConfirm(val) {
      this.idcardForm.nation = val
      this.showMzPicker = false
    },
    // 身份证识别--性别
    onSexConfirm(val) {
      this.idcardForm.sex = val
      this.showSexPicker = false
    },
    // 身份日期show
    showICDate(val) {
      this.showICDatePicker = true
      this.choiceICDate = val
    },
    // 身份日期选中
    onConfirmICDate(val) {
      let da = parseTime(val, '{y}-{m}-{d}')
      if (this.choiceICDate == 'birthday') {
        this.idcardForm.birthday = da
      } else if (this.choiceICDate == 'idbd') {
        this.idcardForm.idbd = da
      } else if (this.choiceICDate == 'ided') {
        this.idcardForm.ided = da
      }
      this.showICDatePicker = false
    },
    // 保存身份证信息
    saveIDcardInfo() {
      this.$emit('saveIDcardInfo', this.idcardForm)     
    }
  }
}
</script>

<style lang="less" scoped>
// 身份证弹窗
.idcard_popup {
  .title_div {
    font-size: 5vw;
    color: #fff;
    padding: 2vw 0;
    text-align: center;
    background: #1a8afa;
    .title {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        position: absolute;
        left: 10px;
      }
    }
  }
  .upload_idcard {
    display: flex;
    padding: 20px;
    .card_po {
      margin-right: 16px;
      background: rgba(224, 240, 255) no-repeat;
      flex: 1;
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url('~@/assets/img/idcard_zhengmian1.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .bank_card {
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url('~@/assets/img/bank_card.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .card_back {
      background: rgba(224, 240, 255);
      flex: 1;
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url('~@/assets/img/idcard_fanmian1.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .idcard_form {
    margin-top: 20px;
    height: calc(100% - 590px);
    overflow-y: auto;
    .van-form {
      .van-cell {
        /deep/.van-cell__title {
          color: #030303;
        }
      }
    }
  }
  .bankCard_form {
    height: calc(100% - 790px) !important;
  }
  .idcard_foot {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 20px;
    text-align: center;
    .van-button {
      width: 90%;
      border-radius: 12px;
    }
  }
}
</style>
